import { render } from "./ClientInstall.vue?vue&type=template&id=771bd1b4"
import script from "./ClientInstall.vue?vue&type=script&lang=js"
export * from "./ClientInstall.vue?vue&type=script&lang=js"

import "./ClientInstall.vue?vue&type=style&index=0&id=771bd1b4&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__